/**
 * Best-effort string description of any thrown value. Handles the three
 * shapes we see in practice:
 *  - `Response` (commonly thrown by TanStack Router loaders for non-2xx)
 *  - `Error` instances
 *  - Anything else (number, null, undefined, plain object, …)
 *
 * Lives in its own module (rather than inline with `ErrorFallback`) so it
 * can be imported by unit tests without dragging in StyleX, which requires
 * a Babel transform at runtime.
 */
export function describeError(e: unknown): string {
  if (e instanceof Response) return `${e.status} ${e.statusText || 'Request failed'}`;
  if (e instanceof Error) return e.message;
  return 'Unknown error';
}
